import { jsxs as _jsxs } from "react/jsx-runtime";
import cx from 'classnames';
import classes from 'app/pages/MyHours/CellDurationTotal/CellDurationTotal.module.scss';
import { Duration as DurationHelper, dateCreateAtMidnight } from 'app/libs/helpers';
const CellDurationTotal = ({ duration, dateISO }) => {
    let finalDuration = duration;
    const date = new Date(dateISO);
    const isFutureDay = date > dateCreateAtMidnight();
    const isFriday = date.getDay() === 5;
    const hoursPerDay = isFriday ? 7 : 8;
    const durationInst = new DurationHelper(finalDuration);
    const durationIsOverLimit = durationInst.isGratherThan({ hours: hoursPerDay });
    const durationData = durationInst.getData(['hours', 'minutes']);
    let minutes = Math.round(durationData.minutes);
    let { hours } = durationData;
    if (hours > hoursPerDay) {
        hours = hoursPerDay;
        minutes = 0;
    }
    if (durationIsOverLimit) {
        finalDuration = new DurationHelper({ hours: hoursPerDay }).getTime();
    }
    const className = cx({
        [classes.noDuration]: !finalDuration,
        [classes.totalPerDay]: finalDuration,
        [classes.noTotalPerDay]: !finalDuration && !isFutureDay,
        [classes.totalPerDayOverLimit]: durationIsOverLimit,
    });
    return (_jsxs("div", { className: className, style: { display: 'flex', justifyContent: 'center' }, children: [hours, "h ", minutes, "m"] }));
};
export default CellDurationTotal;
